// src/ConsumerApp/api/rfq/rfq.service.js
import { apiClient } from '../apiClient';

export const RfqService = {
  /**
   * Fetch customer RFQs filtered by status
   */
  getRfqsByCustomer: async ({ customerId, rfqs = 'all' }) => {
    const response = await apiClient.get(
      `/brickbucket/customer/rfq/get-rfqs-by-customer?customerId=${customerId}&Rfqs=${rfqs}`
    );
    return response.data || response;
  },

  /**
   * Fetch full RFQ details by RFQ ID
   */
  getRfqById: async (rfqId) => {
    const response = await apiClient.get(
      `/brickbucket/customer/rfq/get-rfq-by-id?RFQId=${rfqId}`
    );
    return response.data || response;
  },
};